export const BASKETBALL_TABLE_TYPES = ['PLAYED', 'WINS', 'LOSSES', 'TOTAL_POINTS', 'PERCENTAGE'];
export const BASKETBALL_MOBILE_TYPES = ['WINS', 'LOSSES', 'PERCENTAGE'];

export const ICE_HOCKEY_TABLE_TYPES = [
  'PLAYED',
  'WINS',
  'WINS_OVER_TIME',
  'LOSSES',
  'LOSSES_OVER_TIME',
  'WINS_PENALTY',
  'LOSSES_PENALTY',
  'GOAL_DIFFERENCES',
  'POINTS',
];
export const ICE_HOCKEY_MOBILE_TYPES = ['PLAYED', 'GOAL_DIFFERENCES', 'POINTS'];

export const GROUP_TYPES = {
  OVERALL: 'OVERALL',
  DIVISION: 'DIVISION',
  CONFERENCE: 'CONFERENCE',
};
